import { render } from "./view-quotation.vue?vue&type=template&id=239f700d"
import script from "./view-quotation.vue?vue&type=script&lang=js"
export * from "./view-quotation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__